type EventCallback = (...args: any[]) => void;
class Event {
  private events: { [key: string]: EventCallback[] } = {};

  on(eventName: string, callback: EventCallback) {
    if (!this.events[eventName]) {
      this.events[eventName] = [];
    }
    this.events[eventName].push(callback);
  }

  emit(eventName: string, ...args: any[]) {
    if (!this.events[eventName]) {
      return;
    }
    this.events[eventName].forEach((callback) => {
      callback(...args);
    });
  }

  off(eventName: string, callback?: EventCallback) {
    if (!this.events[eventName]) {
      return;
    }
    if (callback === undefined) {
      delete this.events[eventName];
      return;
    }
    this.events[eventName] = this.events[eventName].filter(
      (eventCallback) => eventCallback !== callback,
    );
  }
}

export default Event;
